<template>
  <div class="togglecon showsmonly" v-if="hasAuthed">
    <div class="toggleout" @click="onToggleSidebar">
        <Icon src="toggle" class='togglesvg'/>   
    </div> 
 </div> 
</template>

<script>
export default {
  name: 'MToggle',
  computed:{
     isCollapsed(){
       return this.$store.getters.isCollapsed
     },
     hasAuthed(){
          return this.$store.state.user.token!=''?true:false 
     }
  },
  methods: {
     onToggleSidebar(){
         this.$store.commit("TOGGLE_SIDEBAR",{isCollapse:!this.isCollapsed})
     }
  }
}
</script>

<style scoped lang="scss">
@media screen and (max-width:767px){
.toggleout{width:0.8rem;height:0.8rem;background-color: #F6F6F6;display: flex;flex-flow: row nowrap;align-items: center;justify-content: center;border-radius: 50%;}
.togglecon{position: fixed;bottom: 0.8rem;right: 0.8rem;z-index:999;}
.togglesvg{width:0.5rem;height:0.5rem;}
}
</style>
